import React from 'react';
import { Box, Typography } from '@mui/material';

function DistributionAgreement() {
    return (
        <Box sx={{ padding: '20px' }}>
            <Typography variant="h5" gutterBottom>
                FM DIGITAL CONTENT LICENSE AGREEMENT
            </Typography>
            <Typography variant="body1" gutterBottom>
                This Agreement, made on [Date] between:
            </Typography>

            <Box sx={{ paddingLeft: '20px', marginBottom: '16px' }}>
                <Typography variant="body1">
                    <strong>Artist/Label:</strong> [Artist Name]
                </Typography>
                <Typography variant="body1">
                    <strong>Address:</strong> [Artist Address]
                </Typography>
                <Typography variant="body1">
                    <strong>Agreement Period:</strong> [Start Date] to [End Date]
                </Typography>
                <Typography variant="body1">
                    (hereinafter referred to as the "Artist" or "Licensor")
                </Typography>
            </Box>

            <Typography variant="body1">
                AND
            </Typography>

            <Box sx={{ paddingLeft: '20px', marginBottom: '16px' }}>
                <Typography variant="body1">
                    FM Digital Official, having its office at F-931/6, Raj Nagar, Uttar Pradesh - 201102, acting through its Managing Director Mr. Ashish Rajput,
                </Typography>
                <Typography variant="body1">
                    (hereinafter referred to as "FM Digital Official" or "Licensee").
                </Typography>
            </Box>

            <Typography variant="body1" gutterBottom>
                WHEREAS the Artist owns and controls exclusive rights to certain musical works ("Said Works"), and FM Digital Official is engaged in the distribution, production, and promotion of music content, the parties hereby agree to the following terms:
            </Typography>

            <Box sx={{ paddingLeft: '20px' }}>
                {/* Section 1 */}
                <Typography variant="h6" gutterBottom>
                    1. Assignment of Rights
                </Typography>
                <Typography variant="body1" gutterBottom>
                    The Artist hereby assigns all copyright, performing, mechanical, and synchronization rights of the Said Works to FM Digital Official for the entire world and for the full term of copyright. This includes but is not limited to the rights to:
                </Typography>
                <Typography variant="body2" component="ul">
                    <li>Reproduce, distribute, and communicate the works to the public.</li>
                    <li>Create adaptations, translations, and synchronizations.</li>
                    <li>Use the works for any digital/mobile content formats, including ringtones, ring-back tones, and more.</li>
                </Typography>

                {/* Section 2 */}
                <Typography variant="h6" gutterBottom>
                    2. Consideration
                </Typography>
                <Typography variant="body1" gutterBottom>
                    FM Digital Official agrees to pay the Artist:
                </Typography>
                <Typography variant="body2" component="ul">
                    <li>A one-time lump sum royalty for the rights, upon signing.</li>
                    <li>Additional compensation per the subscription model: 70% of revenue to the Artist in the Free Plan, and 100% in the Premium Plan.</li>
                </Typography>

                {/* Section 3 */}
                <Typography variant="h6" gutterBottom>
                    3. Territory
                </Typography>
                <Typography variant="body1" gutterBottom>
                    This Agreement applies globally, and FM Digital Official is authorized to distribute and license Said Works across all territories.
                </Typography>

                {/* Section 4 */}
                <Typography variant="h6" gutterBottom>
                    4. Artist’s Warranties
                </Typography>
                <Typography variant="body1" gutterBottom>
                    The Artist guarantees:
                </Typography>
                <Typography variant="body2" component="ul">
                    <li>They are the exclusive owner of the Said Works.</li>
                    <li>The works do not infringe on any third-party rights or contain any unlawful content.</li>
                    <li>The Artist will indemnify FM Digital Official from any legal claims arising from the breach of this warranty.</li>
                </Typography>

                {/* Section 5 */}
                <Typography variant="h6" gutterBottom>
                    5. Term and Renewal
                </Typography>
                <Typography variant="body1" gutterBottom>
                    The Agreement is valid for a tenure of 2 years from the Artist's joining date. If the Artist does not respond to a renewal email from FM Digital Official by the end of the agreement period, the agreement will automatically renew for another 2-year term, under the same terms and conditions.
                </Typography>

                {/* Section 6 */}
                <Typography variant="h6" gutterBottom>
                    6. Force Majeure
                </Typography>
                <Typography variant="body1" gutterBottom>
                    Neither party will be liable for delays caused by acts of God, strikes, or other uncontrollable events.
                </Typography>

                {/* Section 7 */}
                <Typography variant="h6" gutterBottom>
                    7. Arbitration and Governing Law
                </Typography>
                <Typography variant="body1" gutterBottom>
                    Any disputes arising from this Agreement will be subject to arbitration in [Jurisdiction], and this Agreement will be governed by the laws of India.
                </Typography>

                {/* Section 8 */}
                <Typography variant="h6" gutterBottom>
                    8. Takedown Fees
                </Typography>
                <Typography variant="body1" gutterBottom>
                    If a takedown request is made for a track less than 1 year old, the Artist will pay $3 per takedown.
                </Typography>

                {/* Section 9 */}
                <Typography variant="h6" gutterBottom>
                    9. No Partnership
                </Typography>
                <Typography variant="body1" gutterBottom>
                    This Agreement does not constitute a partnership or joint venture between the parties.
                </Typography>

                {/* Section 10 */}
                <Typography variant="h6" gutterBottom>
                    10. Application to Past and Future Artists
                </Typography>
                <Typography variant="body1" gutterBottom>
                    Note: This agreement shall apply to all current, past, and future artists working with FM Digital Official, regardless of when they started or ended their association with the company.
                </Typography>

                {/* Signature Section */}
                <Typography variant="body1" gutterBottom>
                    In witness whereof, the parties have executed this Agreement on the date first above written.
                </Typography>
                <Box sx={{ marginTop: '20px' }}>
                    <Typography variant="body1">Artist/Label Signature: ________________________</Typography>
                    <Typography variant="body1">FM Digital Official Signature: Ashish Rajput</Typography>
                </Box>
            </Box>
        </Box>
    );
}

export default DistributionAgreement;
